<div class="row onetimepay-container">
  @if ((reviewItems$ | async)?.length > 0) {
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <confirmation
        [config]="config$ | async"
        (primaryEvent)="primaryButtonClick()"
        (tertiaryEvent)="done()"
      >
        <!-- account details section -->
        <amfam-one-time-pay-review-item
          [accounts]="reviewItems$ | async"
          [errorItem]="errorItem"
        ></amfam-one-time-pay-review-item>
      </confirmation>
    </div>
  }
</div>
